import React from "react";
import { ListPageHeader } from "../../common/DataList";
import { Tabs, TabPanel, useFicheTabs } from "../../common/Fiche";
import PropositionsSanctionFTList from "./PropositionsSanctionFTList";
import DeclarationsSanctionCAFList from "./DeclarationsSanctionCAFList";

/**
 * Tout ce qui s'échange avec France Travail en matière de sanctions, en deux
 * parties — et non en une liste unique.
 *
 * Le fait générateur n'est pas le même : d'un côté France Travail nous demande
 * quelque chose, de l'autre la CAF décide et transmet. La réponse envoyée à une
 * proposition figure déjà sur la ligne de cette proposition ; les fondre
 * mettrait le même dossier à deux endroits, avec deux états à rapprocher. Les
 * volumes vont d'ailleurs diverger, la CAF déclarant toute sanction d'EP.
 *
 * Les onglets sont nommés par le RÉFÉRENT UNIQUE de l'allocataire, jamais par
 * le sort de la sanction : « Décisions transmises » serait ambigu, puisque les
 * deux volets transmettent. « Propositions reçues » / « sanctions déclarées »
 * n'étaient pas compris non plus (point Caf du 28/10/2026, ST1-2209) : la Caf
 * lit « orientés France Travail » d'un côté, « les autres » de l'autre.
 *
 * Mise en page du kit DataList (en-tête, cartes de recherche et de résultats),
 * comme la liste des allocataires : le contenu de chaque onglet est une liste
 * à part entière, avec ses filtres et sa pagination.
 */
const ONGLETS = [
  {
    id: "propositions",
    label: "Allocataires orientés France Travail",
    icon: "fa-inbox",
  },
  {
    id: "declarations",
    label: "Autres référents uniques",
    icon: "fa-paper-plane",
  },
];

const SanctionsFTPage = () => {
  const { activeId, select } = useFicheTabs({
    tabs: ONGLETS,
    defaultId: "propositions",
    storageKey: "espoar.boa.sanctionsFT.onglet",
    syncHash: true,
  });

  return (
    <div className="container-fluid px-5 my-5 list-page">
      <ListPageHeader
        title="Sanctions France Travail"
        subtitle="Propositions de sanction reçues de France Travail pour les allocataires qu'il suit, et sanctions des autres référents uniques que la CAF lui déclare, avec leur suivi."
      />

      <Tabs
        tabs={ONGLETS}
        activeId={activeId}
        onChange={select}
        idPrefix="sanctions-ft"
        ariaLabel="Sanctions France Travail"
      />

      {/* Chaque panneau garde ses propres filtres et sa propre pagination :
          l'un ne doit pas réinitialiser l'autre en changeant d'onglet. */}
      <TabPanel id="propositions" activeId={activeId} idPrefix="sanctions-ft">
        <PropositionsSanctionFTList />
      </TabPanel>
      <TabPanel id="declarations" activeId={activeId} idPrefix="sanctions-ft">
        <DeclarationsSanctionCAFList />
      </TabPanel>
    </div>
  );
};

export default SanctionsFTPage;
